import { apiClient, API } from "../lib/api";

export const employeeApi = {
  list: () => apiClient.get("/employees"),
  stats: () => apiClient.get("/employees/stats"),
  listSchedulable: () => apiClient.get("/employees/schedulable"),
  get: (id) => apiClient.get(`/employees/${id}`),
  create: (payload) => apiClient.post("/employees", payload),
  update: (id, payload) => apiClient.patch(`/employees/${id}`, payload),
  archive: (id) => apiClient.post(`/employees/${id}/archive`),
  reactivate: (id) => apiClient.post(`/employees/${id}/reactivate`),
  updateWorkStatus: (id, status, reason) => apiClient.post(`/employees/${id}/work-status`, { status, reason }),
  photoUrl: (id) => `${API}/employees/${id}/photo`,
  uploadPhoto: (id, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return apiClient.post(`/employees/${id}/photo`, formData, { headers: { "Content-Type": "multipart/form-data" } });
  },
  deletePhoto: (id) => apiClient.delete(`/employees/${id}/photo`),
  listStoreAssignmentReview: () => apiClient.get("/employees/store-assignment-review"),
  resolveStoreAssignmentReview: (id, action, storeId, reason) =>
    apiClient.post(`/employees/${id}/store-assignment-review`, { action, store_id: storeId, reason }),
  transferStore: (id, newStoreId, reason, effectiveDate) =>
    apiClient.post(`/employees/${id}/transfer-store`, { new_store_id: newStoreId, reason, effective_date: effectiveDate || undefined }),
  getTransferPreview: (id, newStoreId) => apiClient.get(`/employees/${id}/transfer-store/preview`, { params: { new_store_id: newStoreId } }),
};

// Monthly Record tab (Employee History Timeline) - period-scoped, independently-fetched
// sections. Each call is its own request so one section's failure/permission-denial never
// blocks another (see MonthlyRecordTab.jsx).
export const employeeHistoryApi = {
  schedule: (id, period) => apiClient.get(`/employees/${id}/history/schedule`, { params: { period } }),
  availability: (id, period) => apiClient.get(`/employees/${id}/history/availability`, { params: { period } }),
  reconciliation: (id, period) => apiClient.get(`/employees/${id}/history/reconciliation`, { params: { period } }),
  payroll: (id, period) => apiClient.get(`/employees/${id}/history/payroll`, { params: { period } }),
};

export const employeeCleanupApi = {
  listCandidates: () => apiClient.get("/employee-cleanup/candidates"),
  previewOne: (employeeId) => apiClient.get(`/employee-cleanup/${employeeId}/preview`),
  previewBulk: (employeeIds) => apiClient.post("/employee-cleanup/preview-bulk", { employee_ids: employeeIds }),
  execute: (employeeIds, action, confirmationText, batchId) =>
    apiClient.post("/employee-cleanup/execute", { employee_ids: employeeIds, action, confirmation_text: confirmationText, batch_id: batchId }),
};
